import { createFileRoute, redirect } from '@tanstack/react-router';

import { PortalShell } from '@/app/portal-shell/PortalShell';
import { ApiError } from '@/lib/api/errors';
import { sessionQueryOptions } from '@/lib/session/session-queries';
import { useAuthStore } from '@/lib/session/auth-store';
import { telemetry } from '@/lib/telemetry';

/*
 * Portal session gate (mock-first first pass — see ADR 0009). A SEPARATE route
 * segment from _auth: keeping the portal on its own segment encodes "two
 * surfaces" without encoding "one session" or "two sessions" — the session-scope
 * question (AC-0cb9f846) is Proposed, not Approved, so we stay neutral on it.
 *
 * Authentication, however, is shared: both surfaces authenticate against the
 * same /me seam, so the gate semantics mirror _auth exactly — prime /me, derive
 * the session into the auth store, set telemetry, redirect to /login on 401. No
 * tpabilling_client role check is added; the server is the authority and ADR
 * 0008's role-degrade keeps an unknown future portal role safe.
 */
export const Route = createFileRoute('/_portal')({
  beforeLoad: async ({ context, location }) => {
    try {
      const session =
        await context.queryClient.ensureQueryData(sessionQueryOptions);
      useAuthStore.getState().setSession(session);
      telemetry.setUser(session.id);
      return { session };
    } catch (error) {
      if (error instanceof ApiError && error.status === 401) {
        useAuthStore.getState().clear();
        throw redirect({
          to: '/login',
          search: { redirect: location.href },
        });
      }
      throw error;
    }
  },
  component: PortalShell,
});
